import { useJournalEntryCommentStore } from "@/stores/models/journal";

export default async function commentExists({ to }) {
    let exists = false;
    let id = to.params.commentId;
    if (id) {
        try {
            const store = useJournalEntryCommentStore();
            let existing = store.item(id);
            if (!existing) {
                await store.fetchItem({
                    query: { id: id, includes: ['user'] },
                    key: "VIEW_COMMENT"
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
